/**
 * O erro de uma chamada à API, com o status HTTP. Mora fora de `api.ts` para o
 * modo demonstração lançar o MESMO erro que a API real: `api.ts` importa
 * `demo-data.ts`, e `demo-data.ts` importando `api.ts` de volta seria um ciclo.
 */
export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    /**
     * TUT-553 — o código da recusa, quando a API manda um no corpo
     * (`{ code, message }`): a tela decide pelo código, e não pela frase.
     */
    public readonly code?: string,
  ) {
    super(message);
  }
}

/**
 * TUT-406 — a consulta da sessão falhou porque NÃO HÁ sessão (401), e não
 * porque a rede caiu ou o servidor errou. Só nesse caso o portão mostra o
 * login; nos outros, mostra o erro com "tentar de novo".
 */
export function ehSessaoAusente(erro: unknown): boolean {
  return erro instanceof ApiError && erro.status === 401;
}

/**
 * TUT-472 (Q044) — o registro não existe (404). Repetir a consulta não o faz
 * aparecer, e "Tentar novamente" é a saída errada: a tela oferece o caminho de
 * volta.
 */
export function ehNaoEncontrado(erro: unknown): boolean {
  return erro instanceof ApiError && erro.status === 404;
}
